import WastePickupTemp from "../assets/templates/WastePickupTemp";

const WastePickup = () => <WastePickupTemp />;

export default WastePickup;